export default {
  id: 'molten.AmplitudeSessionReplayPlugin',
  sort: 100,
  init: molten => {
    molten.addPlugin('AmplitudePlugin', {
      init: async options => {
        const {
          sessionReplayPlugin
        } = await import('@amplitude/plugin-session-replay-browser');
        return sessionReplayPlugin();
      }
    });
  }
};